import { Button } from 'design-system';
import { ArrowUpRight, Bot } from 'lucide-react';

import { useNoMessagesScreen } from './useNoMessagesScreen';

const NoMessagesScreen = ({
  prompts = [
    'What data have you launched recently?',
    'Give me an overview of your US Nat Gas data',
    'What was the Eurobob price yesterday?',
    'Summarise the dynamics on Dated Brent',
    'How do carbon prices compare across projects by quality?'
  ]
}: {
  prompts?: string[];
}) => {
  const { sendMessage } = useNoMessagesScreen();

  return (
    <div className='size-full overflow-auto'>
      <div className='mx-auto flex min-h-full w-full max-w-[44rem] flex-col justify-center px-6 py-10'>
        <div className='flex items-center gap-3'>
          <div className='flex size-11 items-center justify-center rounded-xl border border-gx-highlight/45 bg-gx-highlight/10 text-gx-highlight'>
            <Bot
              aria-hidden='true'
              className='size-5'
            />
          </div>
        </div>
        <h2 className='mt-5 text-2xl font-semibold tracking-tight text-gx-text'>
          What data can I help you find?
        </h2>
        <p className='mt-2 max-w-xl text-sm leading-6 text-gx-subtext'>
          Ask about GX indexes, recent launches, market movements, or compare data across
          commodities.
        </p>
        <p className='mt-7 text-xs font-semibold tracking-wide text-gx-text-secondary uppercase'>
          Try a question
        </p>
        <div className='mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2'>
          {prompts.map(prompt => (
            <Button
              key={prompt}
              className='h-auto min-h-14 justify-between gap-4 whitespace-normal border-gx-border bg-gx-tile-dark/55 px-4 py-3 text-left text-sm leading-5 font-medium hover:border-gx-highlight/55 hover:bg-gx-response'
              size='lg'
              variant='outline'
              onClick={() => {
                sendMessage(prompt);
              }}
            >
              <span>{prompt}</span>
              <ArrowUpRight
                aria-hidden='true'
                className='size-4 shrink-0 text-gx-subtext'
                data-icon='inline-end'
              />
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoMessagesScreen;
